import {useEffect, useRef} from 'react'

import {useTrackingActiveArea} from '../../../../../../../../../contexts/TrackingActiveArea/TrackingActiveAreaContext'
import {useJobId} from '../../../../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import useValidationErrorMessage from '../../../../../../../../../hooks/useValidationErrorMessage'
import type {SmartDetectorProps} from '../SmartDetectors.types'

import type {ErrorValidatorsKeys} from './useCliErrorMessage.consts'
import {errorValidators} from './useCliErrorMessage.consts'

function useCliErrorMessage({
  value,
  name,
  stepIndex,
  anchorElement,
  disabled,
  focused,
}: SmartDetectorProps) {
  const jobId = useJobId()!
  const didMount = useRef<boolean>(false)
  const {isActiveArea} = useTrackingActiveArea()
  const cliErrorSpotErrorId = `cli_error_${jobId}_step_${stepIndex}_type_${name}`
  const isValueChanged = value !== anchorElement?.defaultValue
  const validators = errorValidators?.[name as ErrorValidatorsKeys] ?? []
  const {errorMessage: cliErrorMessage, handlerValidationError} = useValidationErrorMessage(
    {
      value,
      disabled,
      validators,
    },
    cliErrorSpotErrorId,
    jobId,
  )
  const isShowPopupError = cliErrorMessage && !focused && !disabled

  useEffect(() => {
    if ((!focused && didMount.current && !isActiveArea) || (isValueChanged && focused)) {
      handlerValidationError()
    }
    didMount.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused, isValueChanged, isActiveArea])

  return {
    cliErrorMessage,
    isShowPopupError,
  }
}

export default useCliErrorMessage
